/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import * as MsDyn365 from '@msdyn365-commerce/core';

import { IEcommContentTemplate2Data } from './ecomm-content-template-2.data';
import { IEcommContentTemplate2Props } from './ecomm-content-template-2.props.autogenerated';

export interface IEcommContentTemplate2ViewProps extends IEcommContentTemplate2Props<IEcommContentTemplate2Data> {
    description: React.ReactNode;
    firstImage: MsDyn365.IImageData;
    secondImage: MsDyn365.IImageData;
    anchorID: string;
    TemplateContainerStyle: any;
    InfoContainerStyle: any;
    ImageContainerStyle: any;
    FirstContainerStyle: any;
    SecondContainerStyle: any;
    NoImage: any;
}

/**
 *
 * EcommContentTemplate2 component
 * @extends {React.PureComponent<IEcommContentTemplate2Props<IEcommContentTemplate2Data>>}
 */
class EcommContentTemplate2 extends React.PureComponent<IEcommContentTemplate2Props<IEcommContentTemplate2Data>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const text = config.description && (
            <MsDyn365.RichTextComponent
                text={config.description}
                editProps={{
                    onEdit: this._handleTextChange,
                    requestContext: this.props.context.request
                }}
            />
        );

        const EcommContentTemplateViewProps = {
            ...this.props,
            description: text,
            firstImage: config.firstImage,
            secondImage: config.secondImage,
            anchorID: config.anchorID,
            TemplateContainerStyle: {
                className: 'ecomm-content-template-2'
            },
            InfoContainerStyle: {
                className: 'info-container'
            },
            ImageContainerStyle: {
                className: 'row img-container'
            },
            FirstContainerStyle: {
                className: 'col-12 col-sm-6 first-container'
            },
            SecondContainerStyle: {
                className: 'col-12 col-sm-6 second-container'
            },
            NoImage: {
                className: 'msc-empty_image'
            }
        };

        return this.props.renderView(EcommContentTemplateViewProps);
    }

    private _handleTextChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.description = event.target.value);
}

export default EcommContentTemplate2;
